<template>
  <el-container class="mainBox">
    <el-aside width="220px">
      <img v-if="!isPrivate" class="log_bg" :class="envName" :src="logoBg" alt />
      <img v-else class="log_bg" src="/static/logo_def.png" alt="">
      <h5 :class="hospitalType" v-if="hospitalType==='yibao'">医疗人机合译平台</h5>
      <template v-for="item in menuList">
        <template v-if="!item.children">
          <router-link :to="item.url" :key="item.id">
            <div class="project" :class="item.code" @click="activeElse">
              <span class="navIcon" :class="item.icon"></span>
              {{ item.name }}
            </div>
          </router-link>
        </template>

        <template v-else>
          <h2 :key="item.id">
            <!-- <router-link to=""> -->
            <div class="memory" @click="activeMemory(item)">
              <span class="navIcon" :class="item.icon"></span>
              {{ item.name }}
              <i :class="
                  item.showChild ? 'el-icon-arrow-down' : 'el-icon-arrow-right'
                "></i>
            </div>
            <!-- </router-link> -->
            <p id="werf" v-show="item.showChild ? true : false">
              <template v-for="data in item.children">
                <router-link :to="data.url" :key="data.id">
                  <div class="memorySon" :id="data.tagId">
                    <span class="navIcon" :class="data.icon"></span>
                    {{ data.name }}
                  </div>
                </router-link>
              </template>
            </p>
          </h2>
        </template>
      </template>
    </el-aside>
    <el-container>
      <el-header>
        <div class="top_r">
          <!-- <el-tooltip class="item" effect="dark" content="用户指南" placement="bottom">
            <i class="help" type="info" plain
              style="width:24px;height:24px;margin-right:15px;line-height:0px;cursor:pointer"
              :show-overflow-tooltip="true" @click="goHelp">
            </i>
          </el-tooltip> -->
          <div v-if="!$privatization" style="display: flex;justify-content: center;">
            <el-tooltip id="myWalletTopBut" class="item" effect="dark" content="收支明细" placement="bottom">
              <span v-if="hospitalFlag && !$independence" @click="toUserConter('perCenter/wallet')"
                class="myWalletIcon topIconBox"></span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="译员认证" placement="bottom">
              <span v-if="hospitalFlag && !$independence" @click="toUserConter('perCenter/authentication')"
                class="information topIconBox"></span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="企业认证" placement="bottom">
              <span v-if="hospitalFlag && !$independence" @click="toUserConter('perCenter/companyAuthentication')"
                class="CompanyInformation topIconBox"></span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="意见反馈" placement="bottom">
              <span @click="toUserConter('perCenter/feedback')" class="feedback topIconBox"></span>
            </el-tooltip>
            <!-- <el-tooltip class="item" effect="dark" content="企业认证" placement="bottom">
              <span v-if="hospitalFlag" @click="companyApplicantVisible=true" class="companyIcon topIconBox"></span>
            </el-tooltip> -->
          </div>

          <el-popover placement="bottom" width="200" trigger="manual" v-model="visible" v-if="!$privatization">
            <div class="newsTip">
              <div><i class="el-icon-close" @click="outNewsTip"></i></div>
              <p>
                <img src="../assets/imgs/home/interspace_icon.png" alt="" />&nbsp;&nbsp;点击这里切换团队哦
              </p>
            </div>
            <el-select v-model="interspace" v-if="region.length > 1" placeholder @change="changeCompany"
              :value="interspaceVal" slot="reference">
              <el-option v-for="(item, index) in region" :label="getLabel(item)" :key="index" :value="item.code">
              </el-option>
            </el-select>
            <!-- <el-button >手动激活</el-button> -->
          </el-popover>
          <!-- <el-alert
            title="点击这里切换团队空间哦"
            type="info"
            class="newsTip"
            v-if="region.length>1"
            >
          </el-alert> -->
          <el-tooltip effect="dark" content="用户中心" placement="bottom">
            <!-- <router-link :to="{ path:'/home/userConter',query: {activeName: 'first'}}"> -->
            <a @click="toUserConter('perCenter')" style="cursor:pointer;">
              <img v-if="!$privatization" :src="userImg" alt />
              <img v-if="$privatization" src="../assets/imgs/home/moren_tx.png" alt />
              <span>{{ userName }}</span>
            </a>
            <!-- </router-link> -->
          </el-tooltip>
          <el-tooltip effect="dark" content="退出登录" placement="bottom">
            <span class="out" style="cursor:pointer;" @click="messageIf"></span>
          </el-tooltip>
        </div>
      </el-header>
      <el-main style="overflow:hidden">
        <!-- <input type="text" @input="changeText($event)" v-debounce="search()" /> -->
        <router-view></router-view>
      </el-main>
    </el-container>
    <message-box v-if="mesBox" :isShow="mesBox" tit="友情提示" txt="确定退出登录吗？" :imgSrc="imgSrc" @message="empty"
      @messageIf="messageIf"></message-box>

    <!-- 译贝提示start -->
    <myPopover :styles="styles" :ybVisible="ybVisible"></myPopover>
    <!-- 译贝提示end -->

    <!-- 企业账号申请start -->
    <companyApplicant :companyApplicantVisible='companyApplicantVisible'
      @setCompanyInformationVisible='setCompanyInformationVisible'></companyApplicant>
    <!-- 企业账号申请end -->

    <!-- 新手引导 -->
    <noviceGuide v-if="isNovice" :isNovice="isNovice" :index="numOfGuide" @closeNoviceGuide="closeNoviceGuide">
    </noviceGuide>
  </el-container>
</template>

<script>
//
//import messageBox from "@/common/messageBox.vue";
import myPopover from "@/common/myPopover.vue";
import noviceGuide from "@/common/noviceGuide.vue"; //新手引导
import companyApplicant from "@/common/companyApplicant.vue";
import Cookies from 'js-cookie'
// import Sidebar from "@/common/SideBar.vue";
export default {
  name: "index",
  components: {
    myPopover,
    companyApplicant,
    noviceGuide
  },
  data() {
    return {
      userName: "23",
      menuList: [],
      fal: false,
      count: "00",
      aa: "",
      active: false,
      region: [],
      userImg: require("../assets/imgs/project/head_portrait.png"), // 用户头像
      interspace: "",
      wxCode: "",
      logoBg: '',
      envName: "",
      interspaceVal: localStorage.myCompanyCode,
      imgSrc: require("../assets/imgs/project/qr_code_bg.png"), // 弹窗title背景图
      mesBox: false,
      visible: false,
      userGuideDtoList: "",// 用来引导
      hospitalFlag: true, // 用来在医疗版本不显示议员认证
      styles: {},
      companyApplicantVisible: false,
      hospitalType: "",
      isPrivate:IS_PRIVATE
    };
  },

  computed: {
    routes() {
      return this.$store.getters.routerList;
    },
    ybVisible() {
      if (this.$store.state.ybPopover) {
        let dom = document.getElementById("myWalletTopBut");
        if (dom) {
          this.styles = {
            top: dom.offsetTop + 20 + "px",
            left: dom.offsetLeft - 295 + "px"
          }
        }
      }
      return this.$independence ? false : this.$store.state.ybPopover
    },
    isNovice() {
      return this.$store.state.isNovice;
    },
    numOfGuide() {
      return this.$store.state.numOfGuide;
    }
  },
  updated() {
    this.userName = localStorage.getItem("myUserName");
  },
  beforeDestroy() {
    sessionStorage.clear();
  },
  async created() {
    await this.getUserInfo();
    // this.getCode();
    // 判断用户是否关联手机号

    // let myPhone = localStorage.getItem("myPhone")
    // let temporaryId = localStorage.getItem("temporaryId")
    // // 判断用户是否关联手机号
    // if (myPhone !== '') {
    //   // console.log('当前用户有手机号')
    // } else if (temporaryId == '1') {
    //   // console.log('当前用户有临时手机号')
    // } else {
    //   this.$router.push({ name: 'relation', params: { userId: '123' } });
    //   //this.$router.push('/login/relation');

    // }
    // 如果是医疗版本则不显示译员认证
    if (process.env.VUE_APP_NAME == "hospital") {
      this.hospitalFlag = true //false
    } else {
      this.hospitalFlag = true
    }
    this.hospitalType = process.env.VUE_APP_HOSPITAL;
    this.envName = process.env.VUE_APP_NAME;
    if (!this.logoBg) {
      if (process.env.VUE_APP_HOSPITAL === 'demo' && localStorage.myLogoPic && localStorage.myLogoPic != 'null') {
        this.logoBg = localStorage.myLogoPic;
      } else if (process.env.VUE_APP_HOSPITAL === 'demo') {
        // this.logoBg = `/static/${window.location.host}/logo.png`;
        this.logoBg = require(process.env.VUE_APP_LOGOBG);
      } else if (process.env.VUE_APP_LOGOBG) {
        this.logoBg = require(process.env.VUE_APP_LOGOBG);
      }
    }

    if (localStorage.myUser) {
      var myUser = localStorage.getItem("myUser");
      myUser = JSON.parse(myUser); //把字符串转换成JSON对象
      this.region = myUser.companyList; // 空间数组
      // console.log(myUser,"myUsermyUsermyUsermyUser")
      this.userImg = localStorage.getItem("myUserImg"); // 头像
      this.userName = localStorage.getItem("myUserName"); // 昵称
      this.userGuideDtoList = myUser.userGuideDtoList;
      const lastSelectCompany = JSON.parse(localStorage.lastSelectCompany)
      localStorage.setItem("myId", lastSelectCompany.id);
      localStorage.setItem("myCompanyCode", lastSelectCompany.code); // 公司编码
      if (lastSelectCompany.role) {
        this.roleName = lastSelectCompany.role.name;
        this.interspace = `${lastSelectCompany.name}(${lastSelectCompany.role.name})`;
      } else {
        this.interspace = `${lastSelectCompany.name}`;
      } // 默认选中空间   ///
      // console.log(this.interspace, "this.valuethis.value");
      // this.$store.state.myCompanyCode = this.value;
      this.$store.commit("setCompanyCode", this.interspace);
      // this.wxCode = this.GetQueryString(code)
    } else {
      this.$router.push({ name: "login" });
    }
    await this.queryRes();
  },
  mounted() {
    this.isBlock();
    window.addEventListener("resize", this.isBlock);

    if (this.userGuideDtoList) {
      // 空间引导
      if (this.userGuideDtoList[0].isGuide === 0 && this.region.length > 1 && !this.$privatization) {
        this.visible = true;
        this.isNovice = true
      }
    }
    if (document.getElementsByClassName("current")[0]) {
      // 控制 翻译记忆箭头展示

      var classIf = document.getElementsByClassName("current")[0].firstChild.id;
      if (classIf == "memoryBank" || classIf == "termBank") {
        this.active = true;
      }
    }
  },
  methods: {
    async getUserInfo() {
      const response = await this.catReq1Service("/api/v1/user/getUserInfo");
      if (response.resultCode === "1") {
        let data = response.result;
        let val = JSON.stringify(data);
        localStorage.setItem("myUser", val);
        localStorage.setItem("myPhone", data.loginPhone); // 电话
        localStorage.setItem("myUserImg", data.avatar); // 头像
        localStorage.setItem("myUserName", data.nickName); // 昵称
        localStorage.setItem("myAliasName", data.aliasName); // 别名  --
        localStorage.setItem("lastSelectCompany", JSON.stringify(data.lastSelectCompany));
        localStorage.setItem("myCompanyCode", data.lastSelectCompany.code); // 公司编码
        localStorage.setItem("myId", data.lastSelectCompany.id);
        localStorage.setItem("hasProject", data.isFlagProject); //是否创建过项目
        localStorage.setItem("isEnterEditor", data.isEnterEditor); //是否创建过项目
        return data.lastSelectCompany
      }
    },

    setCompanyInformationVisible(val) {
      this.companyApplicantVisible = val;
    },
    // 上方图标跳转事件
    toUserConter(name) {
      if (this.$independence) {
        let activeName = "first";
        name == "perCenter/feedback" ? activeName = "feedback" : '';
        this.$router.push({
          path: "/home/userConter",
          query: {
            activeName
          }
        })
      } else {
        window.open(PTURL + name)
      }

    },
    isBlock() {
      if (window.innerWidth > 1366) {
        document.body.style.zoom = 1;
      } else {
        // document.body.style.zoom = 0.8;
      }
    },
    // 关闭空间引导
    outNewsTip() {
      let that = this;
      this.catReq1Service("/api/v1/user/closeCompanyChangeGuide").then(function (
        response
      ) {
        if (!response.success) {
          return;
        }
        that.visible = false;
        let myUser = localStorage.getItem("myUser");
        myUser = JSON.parse(myUser); //把字符串转换成JSON对象
        myUser.userGuideDtoList[0].isGuide = 1;
        let val = JSON.stringify(myUser);
        localStorage.setItem("myUser", val);
      });
    },
    // 退出登录弹窗
    messageIf() {
      var that = this;
      if (that.mesBox) {
        that.mesBox = false;
      } else {
        that.mesBox = true;
      }
    },
    empty() {
      this.out();
    },
    goHelp() {
      this.$router.push({ name: "help" });
    },
    // GetQueryString(name) {
    //   var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    //   var r = window.location.search.substr(1).match(reg);
    //   if (r != null) return unescape(r[2]);
    //   return null;
    // },
    getLabel(item) {
      // console.log(item)
      if (item.role) {
        return `${item.name}(${item.role.name})`;
      } else {
        return `${item.name}`;
      }
    },

    // 获取左侧菜单
    queryRes() {
      var that = this;
      this.catReq1Service("/api/v1/resource/queryRes", {}, "post").then(function (
        response
      ) {
        if (response.resultCode === "1") {
          that.menuList = response.result;
          if (process.env.VUE_APP_HOSPITAL == "yibao" || process.env.VUE_APP_HOSPITAL == "shanghai") {
            that.menuList.pop()
          }
          if (that.$privatization) {
            // that.roleName === "项目经理" ? that.menuList.pop() : ''
          }
        }
      });
    },
    // 切换空间
    async changeCompany(query) {
      var that = this;
      // that.$store.state.myCompanyCode = query;
      localStorage.setItem("myCompanyCode", query);
      that.$store.commit("setCompanyCode", query);
      this.catReq1Service("/api/v1/user/changeCompany", { code: query }).then(
        async function (response) {
          if (response.success === true) {
            var data = response.result;
            var val = JSON.stringify(data);
            // localStorage.setItem("myUser", val);

            await that.getUserInfo();  // 调取正取的公司
            if (response.resultCode === "1") {
              // localStorage.setItem("myUserImg", data.avatar); // 头像
              // localStorage.setItem("myUserName", data.nickName); // 昵称
              // localStorage.setItem("myAliasName", data.aliasName); // 别名
            }
            that.queryRes();
            that.$router.push({ name: "homeMiddleware" });
          }
        }
      );
    },
    // 登出
    out() {
      if (this.$independence) {
        let that = this;
        this.catReq1Service("/user/ajaxLogout").then(function (response) {
          if (response.resultCode === "1") {
            that.$router.push({ name: "login" });
          }
        });
        return
      } else {
        localStorage.removeItem('myHeaderUser');
        localStorage.removeItem('myUser');
        let callback = encodeURIComponent(`${window.location.origin}/logout?client_name=${process.env.VUE_APP_CLIENT_NAME}`)
        window.location.href = `${CASURL}/logout?service=${callback}`;
      }

    },
    activeMemory(item) {
      // this.$router.push({ name: "memory" });
      // if (!this.active) {
      item.showChild = !item.showChild;

      // }else{
      //   this.active = false;
      // }
    },
    activeElse() {
      this.active = false;
    },
    changeText(e) {
      var thst = this;
      // thst.aa = false;
      let timer;
      // // console.log(e);
      if (thst.aa) {
        // console.log(0);
        clearTimeout(thst.aa);
      }
      thst.aa = setTimeout(() => {
        // this.aa = true;
        // console.log(666);
      }, 3000);
      // // debugger
    },
    search(e) {
      // 实际要进行的操作 axios.get('')之类的
      // this.count++;
      // // console.log(e);
    },

    handleOpen() { },
    handleClose() { },
    //关闭新手引导
    closeNoviceGuide(index) {
      this.$store.commit("setIsNovice", false);
    }
  },
  beforeRouteEnter(to, from, next) {
    if (window.innerWidth > 992 && window.innerWidth < 1366) {
      document.body.style.zoom = 0.8;
    }
    next();
  }
};
</script>
<style>
::-webkit-scrollbar {
  /* overflow:-Scroll;
    overflow-y:hidden; */
  width: 7px;
  height: 5px;
  background-color: rgba(245, 245, 245, 0.47);
}

/*定义滚动条的轨道，内阴影及圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
/*定义滑块，内阴影及圆角*/
::-webkit-scrollbar-thumb {
  /*width: 10px;*/
  height: 20px;
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(85, 85, 85, 0.25);
}
</style>
<style lang="less">
@media screen and (min-width: 992px) and (max-width: 1500px) {
  body {
    zoom: 0.9;
    height: 100%;
  }
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: content-box;
}
html,
body {
  //zoom: 0.9;
  height: 100%;
}
.el-popover {
  /// 语言对提示框
  min-width: 180px;
  max-width: 482px;
}
.el-message {
  border: 0px solid !important;
  background: rgba(255, 255, 255, 1) !important;
  box-shadow: 3px 4px 16px 0px rgba(0, 0, 0, 0.2) !important;
}
.mainBox {
  text-align: center;
}
.el-header {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 9px 0px rgba(235, 246, 241, 1);
  height: 50px !important;
  border-bottom: 1px solid #d3d3d3;
  .top_r {
    float: right;
    line-height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    // position: relative;
    .help {
      background-image: url(../assets/imgs/help/help_normal.png);
    }
    .help:hover {
      background-image: url(../assets/imgs/help/hover.png);
    }
    p {
      padding-right: 20px;
      font-size: 12px;
      color: #11a4ff;
    }
    .el-select {
      margin-right: 20px;
      .el-input {
        width: 160px;
      }
    }
    img {
      border-radius: 50%;
    }
    input {
      // width: 160px;
      height: 32px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(186, 185, 185, 1);
      border-radius: 2px;
      font-size: 12px;
      line-height: 32px;
    }
    a {
      margin-right: 40px;
      img {
        width: 30px;
        height: 30px;
        vertical-align: middle;
      }
      span {
        margin-left: 20px;
        width: 47px;
        height: 11px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
    .out {
      width: 18px;
      height: 20px;
      margin-right: 60px;
      background: url("../assets/imgs/project/sign_out_normal.png");
    }
    .out:hover {
      background: url("../assets/imgs/project/sign_outhover.png");
    }
    .out :active {
      background: url("../assets/imgs/project/sign_out_press.png");
    }
    .topIconBox {
      margin-right: 20px;
      cursor: pointer;
      display: inline-block;
      width: 22px;
      height: 22px;
    }
    .feedback {
      background: url("../assets/imgs/home/feedback_normal.png") no-repeat;
    }
    .feedback:active {
      background: url("../assets/imgs/home/feedback_press.png") no-repeat;
    }
    .information {
      background: url("../assets/imgs/home/translator_certification_normal.png")
        no-repeat;
      height: 21px;
      background-size: contain;
    }
    .information:active {
      background: url("../assets/imgs/home/translator_certification_press.png")
        no-repeat;
    }
    .CompanyInformation {
      background: url("../assets/imgs/home/enterprise_certification_normal.png")
        no-repeat;
      position: relative;
      top: 1px;
    }
    .CompanyInformation:active {
      background: url("../assets/imgs/home/enterprise_certification_press.png")
        no-repeat;
    }
    .companyIcon {
      background: url("../assets/imgs/home/application_enterprise_normal.png")
        no-repeat;
    }
    .companyIcon:active {
      background: url("../assets/imgs/home/application_enterprise_press.png")
        no-repeat;
    }
    .myWalletIcon {
      background: url("../assets/imgs/home/wallet_normal.png") no-repeat;
    }
    .myWalletIcon:active {
      background: url("../assets/imgs/home/wallet_press.png") no-repeat;
    }
  }
}
.el-container {
  height: 100%;
}
.el-aside {
  background: #eaeaea;
  box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
  height: 100%;

  .log_bg {
    margin: 50px auto;
    display: block;
    margin-bottom: 25px;
    max-width: 180px;
    min-width: 100px;
  }
  h5 {
    color: blue;
    margin-bottom: 40px;
  }
  .yibao {
    font-size: 15px;
    font-weight: bold;
    color: rgba(44, 44, 44, 1);
  }
  .use_help {
    border-top: 1px solid #a8a199;
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
  }
  .memory {
    height: 100%;
    cursor: pointer;
    position: relative;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    i {
      position: absolute;
      left: 140px;
      top: 19px;
    }
  }
  .el-submenu__title {
    width: 200px;
    height: 50px;
    border-radius: 6px;
    line-height: 50px;
    margin: 0 auto;
    margin-top: 20px;
    color: #50649a;
    text-align: left;
  }
  div {
    width: 180px;
    height: 50px;
    border-radius: 6px;
    line-height: 50px;
    margin: 0 auto;
    margin-top: 10px;
    color: #50649a;
    text-align: left;
  }
  .memorySon {
    width: 150px;
    height: 40px;
    // background: rgba(64, 158, 255, 1);
    // box-shadow: 0px 4px 9px 0px rgba(109, 142, 205, 0.8);
    border-radius: 6px;
    line-height: 40px;
    position: relative;
    left: 20px;
    margin-top: 10px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }
  .navIcon {
    display: inline-block;
    width: 19px;
    height: 19px;
    margin-left: 20px;
    margin-right: 15px;
    position: relative;
    top: 3px;
    background: url("../assets/imgs/home/my_mission_normal.png") no-repeat;
  }
  .projectIcon {
    background: url("../assets/imgs/home/my_project_normal.png") no-repeat;
  }
  .manageIcon {
    background: url("../assets/imgs/home/my_team_normal.png") no-repeat;
    position: relative;
    top: 3px;
  }
  .helpIcon {
    background: url("../assets/imgs/home/instructions_normal.png") no-repeat; // 新添加的帮助文档
  }
  .memoryIcon {
    background: url("../assets/imgs/home/translation_memory_normal.png")
      no-repeat;
  }
  .memoryBankIcon {
    background: url("../assets/imgs/home/memory_bank_normal.png") no-repeat;
  }
  .termBankIcon {
    background: url("../assets/imgs/home/terminology_bank_normal.png") no-repeat;
  }
  div:hover {
    // background: rgba(64, 158, 255, 1);
    color: #50649a;
    // box-shadow: 0px 4px 9px 0px rgba(109, 142, 205, 0.8);
  }
  div:hover .navIcon {
    background: url("../assets/imgs/home/my_mission-hover.png") no-repeat;
  }
  div:hover .projectIcon {
    background: url("../assets/imgs/home/my_project_hover.png") no-repeat;
  }
  div:hover .manageIcon {
    background: url("../assets/imgs/home/my_team_hover.png") no-repeat;
  }
  div:hover .helpIcon {
    background: url("../assets/imgs/home/instructions_hover.png") no-repeat;
  }
  div:hover .memoryIcon {
    background: url("../assets/imgs/home/translation_memory_hover.png")
      no-repeat;
  }
  div:hover .memoryBankIcon {
    background: url("../assets/imgs/home/memory_bank_hover.png") no-repeat;
  }
  div:hover .termBankIcon {
    background: url("../assets/imgs/home/terminology_bank_hover.png") no-repeat;
  }
}

.el-loading-mask {
  // loading
  z-index: 1500 !important;
}
.el-main {
  background: #f5f4f4;
  // height: 46vh;
  padding: 15px 15px !important;
  position: relative;
  height: 100%;
}

.el-table__row {
  td {
    .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.el-table {
  table {
    .has-gutter {
      color: #333333 !important;
      th {
        .cell {
          // 表头溢出隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.newsTip {
  div {
    text-align: right;
  }
  p {
    span {
      background: url("../assets/imgs/home/interspace_icon.png");
      width: 20px;
      height: 20px;
    }
    img {
      position: relative;
      top: 4px;
    }
    text-align: center;
    margin-bottom: 10px;
  }
}
</style>
<style lang="less" scoped>
.el-aside {
  .current {
    div {
      background: #125ada;
      box-shadow: 1px 6px 10px 0px rgba(67, 114, 246, 0.2);
      color: rgba(255, 255, 255, 1);
      .navIcon {
        background: url("../assets/imgs/home/my_mission-press.png") no-repeat;
      }
      .projectIcon {
        background: url("../assets/imgs/home/my_project_press.png") no-repeat;
      }
      .helpIcon {
        background: url("../assets/imgs/home/instructions_press.png") no-repeat;
      }
      .manageIcon {
        background: url("../assets/imgs/home/my_team_press.png") no-repeat;
      }
      .memoryIcon {
        background: url("../assets/imgs/home/translation_memory_press.png")
          no-repeat;
      }
      .memoryBankIcon {
        background: url("../assets/imgs/home/memory_bank_normal_press.png")
          no-repeat;
      }
      .termBankIcon {
        background: url("../assets/imgs/home/terminology_bank_press.png")
          no-repeat;
      }
    }
  }
}
</style>
